import React, { FC } from 'react';
import { Typography } from '@mui/material';
import useStyles from './styles';
import Excavator from '../../assets/icons/excavator';

const Loading: FC = () => {
  const classes = useStyles();
  return (
    <div className={classes.pageContainer}>
      <Excavator />
      <Typography variant="h1" className={classes.title}>
        loading...
      </Typography>
    </div>
  );
};

export default Loading;
